import { render, staticRenderFns } from "./PhotographyDisputeDialog.vue?vue&type=template&id=453492fc&scoped=true&"
import script from "./PhotographyDisputeDialog.vue?vue&type=script&lang=js&"
export * from "./PhotographyDisputeDialog.vue?vue&type=script&lang=js&"
import style0 from "./PhotographyDisputeDialog.vue?vue&type=style&index=0&id=453492fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "453492fc",
  null
  
)

export default component.exports